import {Component, Input} from '@angular/core';

import {isNil, toLower} from 'lodash-es';

@Component({
    selector: 'app-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.scss'],
    standalone: false
})
export class StatusComponent {

  @Input() statusText: string;
  @Input() renderAs = 'status';
  @Input() statusField;

  public isNil = (item: string) => isNil(item) || item === 'null';

  statusClass(): string {
    const baseClass: string = this.renderAs === 'icon' ? 'status_icon' : 'status';

    if (this.statusField === 'activeVisit') {
      // Active visit statuses
      switch (this.statusText) {
        case 'Saved':
          return `${baseClass}__active_visit_saved`;
        case 'Paused':
          return `${baseClass}__active_visit_paused`;
        case 'In Progress':
          return `${baseClass}__active_visit_in_progress`;
      }
    }

    switch (this.statusText) {
      case 'Logged Out': return `${baseClass}__logged_out`;
      case 'Available': return this.getAvailableClass(baseClass);
      case 'Submitting Report': return `${baseClass}__on_call`;
      case 'Paused': return this.getPausedClass(baseClass);
      case 'On': return this.getAvailableClass(baseClass);
      case 'Off': return `${baseClass}__logged_out`;
      case 'On Call': return `${baseClass}__on_call`;
      case 'Busy': return `${baseClass}__on_call`;
      case 'Problem': return this.getPausedClass(baseClass);
      case 'Active': return this.getAvailableClass(baseClass);
      case 'Pending': return `${baseClass}__pending`;
      case 'Suspended': return this.getSuspendedClass(baseClass);
      case 'Archived': return `${baseClass}__on_call`;

      // Job statuses
      case 'Not Started': return `${baseClass}__not_started`;
      case 'In Progress': return `${baseClass}__paused`;
      case 'Scheduled': return `${baseClass}__scheduled`;
      case 'Not Scheduled': return `${baseClass}__logged_out`;
      case 'Past Due': return `${baseClass}__past_due`;
      case 'Incomplete': return `${baseClass}__incomplete`;
      case 'Complete': return `${baseClass}__complete`;
    }
    return baseClass;

  }

  statusIcon(): string {
    const icons: any = {
      'oncall-callcondition': 'phone_in_talk',
      'on-callcondition': 'phone',
      'off-callcondition': 'phone',
      'problem-callcondition': 'phone_disabled',
      'active-sensorcondition': 'wifi',
      'suspended-sensorcondition': 'wifi',
      'problem-sensorcondition': 'wifi_off',
    };
    const icon = `${toLower(this.statusText).replace(' ', '')}-${toLower(this.statusField)}`;

    return icons[icon];
  }

  private getSuspendedClass(baseClass: string): string {
    if (this.statusField === 'sensorCondition') {
      return `${baseClass}__suspended ${baseClass}__rotated-90`;
    } else {
      return `${baseClass}__paused`;
    }
  }

  private getAvailableClass(baseClass: string): string {
    if (this.statusField === 'sensorCondition') {
      return `${baseClass}__rotated-90`;
    } else {
      return `${baseClass}__available`;
    }
  }

  private getPausedClass(baseClass: string): string {
    if (this.statusField === 'callCondition' || this.statusField === 'sensorCondition') {
      return `${baseClass}__rotated-90`;
    } else {
      return `${baseClass}__paused`;
    }
  }
}
